import 'promise-polyfill/src/polyfill';

import './libraries/slimmageSettings';
import './libraries/slimmage';
// App
import App from './app';
import PolyfillController from './controllers/polyfill';

// Controllers
import HeaderController from './controllers/header';
import MediaController from './controllers/media';
import ConsentController from '@humandigital-agency/consent-controller';
import SliderController from './controllers/slider';
import AccordeonController from './controllers/accordeon/controller';

(async () => {
    document.querySelector('html').classList.remove('no-js');

    const polyfills = new PolyfillController();
    await polyfills.init();

    try {
        const app = new App();
        app.resizeThrottle = 10;
        app.scrollThrottle = 100;
        window.app = app;
        
        app.polyfillController = polyfills;
        
        app.ConsentController = new ConsentController();
        app.headerController = new HeaderController();
        app.mediaController = new MediaController();
        app.sliderController = new SliderController();
        app.accordeonController = new AccordeonController();

        // Modules
        const loadModules = () => {
            if (document.querySelector('.shareContainer')) {
                import( /* webpackChunkName: "modules/share" */ './controllers/share/controller').then(e => {
                    app.ShareController = new e.default();
                });
            }
    
            if (document.querySelector('[data-gallery]')) {
                import( /* webpackChunkName: "modules/gallery" */ './controllers/gallery').then(e => {
                    app.galleryController = new e.default();
                });
            }
    
            if (document.querySelector('.tabs')) {
                import( /* webpackChunkName: "modules/tabs" */ './controllers/tabs/controller').then(e => {
                    app.tabController = new e.default();
                });
            }
    
            if (document.querySelector('body.servicesoverviewpage')) {
                import( /* webpackChunkName: "modules/servicesOverview" */ './controllers/servicesOverview/controller').then(e => {
                    app.servicesOverviewController = new e.default();
                });
            }
    
            if (document.querySelector('body.carelocationsoverviewpage')) {
                import( /* webpackChunkName: "modules/carelocationsoverview" */ './controllers/carelocationsoverview/controller').then(e => {
                    app.careLocationsOverviewController = new e.default();
                });
            }
        };

        loadModules();

        await app.init();
    } catch(e) {
        console.error(`Something went wrong initializing the app`);
        throw e;
    };

    console.log(`App initialized`);
    document.documentElement.classList.remove('preventAnimations');

})();